export const PUBLISHED_BOOKS = [
  {
    title: 'Ten Days Before Troy',
    series: 'Echoes of History · Book 1',
    amazon: 'https://www.amazon.com/s?k=Ten+Days+Before+Troy+Dmitriy+Tyutyunik&i=stripbooks'
  },
  {
    title: 'Ten Days Before London Burned',
    series: 'Echoes of History · Book 2',
    amazon: 'https://www.amazon.com/s?k=Ten+Days+Before+London+Burned+Dmitriy+Tyutyunik&i=stripbooks'
  },
  {
    title: 'Ten Days Before The Titanic Sank',
    series: 'Echoes of History · Book 3',
    amazon: 'https://www.amazon.com/s?k=Ten+Days+Before+The+Titanic+Sank+Dmitriy+Tyutyunik&i=stripbooks'
  },
  {
    title: 'The Duck Protocol',
    series: 'YA AI thriller',
    amazon: 'https://www.amazon.com/s?k=The+Duck+Protocol+Dmitriy+Tyutyunik&i=stripbooks'
  },
  {
    title: "Truck-san Doesn't Want to Kill You",
    series: 'The Depot Files · Book 1',
    amazon: 'https://www.amazon.com/s?k=Truck-san+Doesn%27t+Want+to+Kill+You+Dmitriy+Tyutyunik&i=stripbooks'
  },
  {
    title: 'Legendary Necromancer Reborn',
    series: 'The Bonebinder Chronicles · Book 1',
    amazon: 'https://www.amazon.com/s?k=Legendary+Necromancer+Reborn+Dmitriy+Tyutyunik&i=stripbooks'
  }
];
export const AUTHOR_LINKS = {
  amazon:'https://www.amazon.com/stores/Dmitriy-Tyutyunik/author/B0HGTL13YY',
  goodreads:'https://www.goodreads.com/author/show/71961438.Dmitriy_Tyutyunik'
};
